import Vue from "vue";
import BootstrapVue from "bootstrap-vue";
import fontawesome from "@fortawesome/fontawesome";
import {
  FontAwesomeIcon,
  FontAwesomeLayers
} from "@fortawesome/vue-fontawesome";
import brands from "@fortawesome/fontawesome-free-brands";
import solid from "@fortawesome/fontawesome-free-solid";
import regular from "@fortawesome/fontawesome-free-regular";
import VueAwesomeSwiper from "vue-awesome-swiper";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import "bootstrap-vue/dist/bootstrap-vue.css";
import "swiper/dist/css/swiper.css";
import moment from "moment";
import "moment/locale/ko";
import VueMomentJS from "vue-momentjs";

Vue.config.productionTip = false;

Vue.use(BootstrapVue);
Vue.use(VueAwesomeSwiper);
Vue.use(VueMomentJS, moment);

fontawesome.library.add(brands, solid, regular);

Vue.component("font-awesome-icon", FontAwesomeIcon);
Vue.component("font-awesome-layers", FontAwesomeLayers);

const EMPTY_BOOTSTRAP = {
  isAuthenticated: false,
  user: {},
  primaryCategories: [],
  categories: [],
  fields: [],
  concepts: [],
  colors: [],
  banners: [],
  clients: [],
  bestProjects: { _page: 1, _currentPage: 1, results: [] }
};

// Components read initial data from window.* (window.user, window.categories, ...).
// It used to be injected by a Django template; now it comes from /api/v1/bootstrap/,
// prefetched in public/index.html so it loads in parallel with this bundle.
async function bootstrap() {
  const request =
    window.__bootstrap ||
    fetch("/api/v1/bootstrap/", { credentials: "same-origin" }).then(r => {
      if (!r.ok) throw new Error(`bootstrap ${r.status}`);
      return r.json();
    });
  try {
    Object.assign(window, EMPTY_BOOTSTRAP, await request);
  } catch (error) {
    // eslint-disable-next-line no-console
    console.error("Failed to load initial data", error);
    Object.assign(window, EMPTY_BOOTSTRAP);
  }
  new Vue({
    router,
    store,
    render: h => h(App)
  }).$mount("#app");
}

bootstrap();
